import { Component, EventEmitter, forwardRef, Inject, Input, OnInit, Output, ViewContainerRef } from '@angular/core';
import { ALERT_TIMELINE_WIDGET_TAG } from '../../common/constants';
import { Alert } from '../../model';
import { ThingContextService } from '../../service/thing-context.service';
import { WidgetRegistrationService } from '../../service/widget-registration.service';
import { TemplateLoadStatus } from '../template-loader/template-load-status';
import { TemplateLoaderService } from '../template-loader/template-loader.service';

/**
 * Hosts the external alert-timeline-widget through the dynamic template compiler.
 * The widget consumes the current alert from the shared context.
 * Emits the load outcome so the dialog can show a section-local warning without affecting other sections.
 */
@Component({
    selector: 'event-details-timeline',
    template: '',
    styles: [`
        :host {
            display: block;
        }
    `]
})
export class EventDetailsTimelineComponent implements OnInit {

    @Input() alert: Alert;

    @Output() loadStatus = new EventEmitter<TemplateLoadStatus>();

    private static readonly TIMELINE_TEMPLATE = `<${ALERT_TIMELINE_WIDGET_TAG}></${ALERT_TIMELINE_WIDGET_TAG}>`;

    constructor(
        @Inject(forwardRef(() => ViewContainerRef)) private vcRef: ViewContainerRef,
        @Inject(forwardRef(() => TemplateLoaderService)) private templateLoaderService: TemplateLoaderService,
        @Inject(forwardRef(() => ThingContextService)) private thingContextService: ThingContextService,
        @Inject(forwardRef(() => WidgetRegistrationService)) private widgetRegistrationService: WidgetRegistrationService
    ) { }

    ngOnInit(): void {
        // 1. Do nothing if the timeline widget is not installed.
        if (!this.widgetRegistrationService.hasWidget(ALERT_TIMELINE_WIDGET_TAG)) {
            return;
        }
        try {
            // 2. Put this event in the shared context, which the widget reads.
            if (this.alert) {
                this.thingContextService.updateCurrentAlert(this.alert);
            }
            // 3. Render the widget tag through the template compiler.
            this.templateLoaderService.loadFromText(
                EventDetailsTimelineComponent.TIMELINE_TEMPLATE, this.vcRef, true,
                null, null, false)
                // 4. Report the outcome to the dialog.
                .then(() => this.loadStatus.emit(TemplateLoadStatus.LOADED))
                .catch(() => this.loadStatus.emit(TemplateLoadStatus.ERROR));
        } catch {
            // 5. An error thrown before the load starts is reported the same way.
            this.loadStatus.emit(TemplateLoadStatus.ERROR);
        }
    }
}
